import Vue from 'vue';
import './layout.scss';
import '../../applications/about-us-timeline/about-us-timeline.js';
import layoutBase from '../layout-base';
import mhap from '../../modules/MHAP/mhap';
import mstb from '../../modules/MSTB/mstb';
import mvtu from '../../modules/MVTU/mvtu';
import videoPlayer from '../../common/components/video-player/video-player.vue';
import VueYouTubeEmbed from 'vue-youtube-embed';
import YoutubePLayer from '../../common/components/youtube-player/youtube-player.vue';
import mgfac from '../../modules/MGFAC/mgfac';
import macc from '../../modules/MACC/macc';
import announcementsSelect from '../../common/components/announcements-select/announcements-select.js';
import '../../applications/donation/donation.js';

Vue.component('YoutubePlayer', YoutubePLayer);

Vue.use(VueYouTubeEmbed);
new Vue({
	extends: layoutBase,
	components: { mstb, mvtu, macc, mgfac, mhap, videoPlayer, announcementsSelect }
}).$mount('[data-layout-id="ATER-app"]');
